import React, {type ReactNode} from 'react'
import type {NotifyOptions, ToastVariant} from './types'

const BASE_READING_TIME_MS = 2500
const READING_TIME_PER_WORD_MS = 300

const DURATION_LIMITS: Record<ToastVariant, {min: number; max: number}> = {
    success: {min: 5000, max: 9000},
    info: {min: 5000, max: 9000},
    warning: {min: 6000, max: 10000},
    error: {min: 8000, max: 12000}
}

const readableText = (node: ReactNode): string => {
    if (typeof node === 'string' || typeof node === 'number') return String(node)
    if (Array.isArray(node)) return node.map(readableText).join(' ')
    if (React.isValidElement<{children?: ReactNode}>(node)) {
        return readableText(node.props.children)
    }
    return ''
}

export const resolveToastDuration = (
    variant: ToastVariant,
    message: ReactNode,
    options?: NotifyOptions
) => {
    if (options?.persistent) return 0
    if (options?.durationMs !== undefined) return Math.max(0, options.durationMs)

    const text = options?.readingText?.trim() || readableText(message).trim()
    const wordCount = text ? text.split(/\s+/u).length : 0
    const readingTime = BASE_READING_TIME_MS + wordCount * READING_TIME_PER_WORD_MS
    const {min, max} = DURATION_LIMITS[variant]
    return Math.min(max, Math.max(min, readingTime))
}
